<ng-container *transloco="let t">
  <div
    class="fixed inset-0 z-[70] flex items-end keyboard-aware-container"
    [style.padding-bottom.px]="keyboardHeight()"
  >
    <div
      id="link-loan-mfa-dialog-container"
      class="bg-white w-full rounded-t-2xl shadow-xl flex flex-col overflow-hidden mfa-dialog-slide-up"
      [style.max-height]="'calc(100dvh - env(safe-area-inset-top, 0px) - ' + keyboardHeight() + 'px)'"
      style="padding-bottom: env(safe-area-inset-bottom, 0px)"
    >
      <div
        id="link-loan-mfa-dialog-header"
        class="flex items-center justify-between px-4 py-3 bg-black rounded-t-2xl shrink-0"
      >
        <div class="flex items-center gap-2">
          @if (currentStep() === 'enter-code') {
            <button
              id="link-loan-mfa-dialog-back-btn"
              type="button"
              class="flex items-center justify-center size-8 bg-transparent border-none cursor-pointer text-white"
              aria-label="Go back"
              (click)="onVerificationCancel()"
            >
              <mat-icon>arrow_back</mat-icon>
            </button>
          }
          <span class="font-dm text-base font-semibold text-white">{{ t('mfaVerificationTitle') }}</span>
        </div>
        <button
          id="link-loan-mfa-dialog-close-btn"
          type="button"
          class="flex items-center justify-center size-8 bg-transparent border-none cursor-pointer text-white"
          aria-label="Close"
          (click)="onCancel()"
        >
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <div id="link-loan-mfa-dialog-content" class="p-6 overflow-y-auto flex-1">
        @if (isLoading()) {
          <div id="link-loan-mfa-dialog-loading" class="flex flex-col items-center justify-center py-8">
            <mat-spinner diameter="48"></mat-spinner>
          </div>
        } @else {
          @switch (currentStep()) {
            @case ('select-method') {
              @if (errorMessage()) {
                <div
                  id="link-loan-mfa-dialog-error"
                  role="alert"
                  class="mb-4 rounded-lg border border-ld-error/30 bg-ld-error/10 px-4 py-3 font-dm text-sm text-ld-error"
                >
                  {{ errorMessage() }}
                </div>
              }
              <p id="link-loan-mfa-dialog-description" class="font-dm text-sm text-ld-neutral-500 mb-6 text-left">
                {{ t('mfaVerificationDescription') }}
              </p>
              @if (getMfaDescription()) {
                <p
                  id="link-loan-mfa-dialog-email-only-desc"
                  class="font-dm text-xs text-ld-neutral-400 mb-4 text-left italic"
                >
                  {{ getMfaDescription() }}
                </p>
              }
              <div class="flex flex-col gap-4 mb-6">
                @if (data.emailOptions.length > 0) {
                  <mat-form-field appearance="outline" class="w-full mfa-dialog-dropdown">
                    <mat-label>{{ t('mfaMethodsEmail') }}</mat-label>
                    <mat-select [value]="initialBsEmail()" (selectionChange)="selectedBsEmail.set($event.value)">
                      @for (option of data.emailOptions; track option.value) {
                        <mat-option [value]="option">{{ option.masked || option.label }}</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                }
                @if (data.textOptions.length > 0) {
                  <mat-form-field appearance="outline" class="w-full mfa-dialog-dropdown">
                    <mat-label>{{ t('commonFieldsPhoneNumber') }}</mat-label>
                    <mat-select [value]="initialBsPhone()" (selectionChange)="selectedBsPhone.set($event.value)">
                      @for (option of data.textOptions; track option.value) {
                        <mat-option [value]="option">{{ option.masked || option.label }}</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                }
                @if (data.callOptions.length > 0) {
                  <mat-form-field appearance="outline" class="w-full mfa-dialog-dropdown">
                    <mat-label>{{ t('commonFieldsPhoneNumber') }}</mat-label>
                    <mat-select
                      [value]="initialBsCallPhone()"
                      (selectionChange)="selectedBsCallPhone.set($event.value)"
                    >
                      @for (option of data.callOptions; track option.value) {
                        <mat-option [value]="option">{{ option.masked || option.label }}</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                }
              </div>
              @if (!data.isFirstTimeLinking) {
                <p id="link-loan-mfa-dialog-faq" class="text-left font-dm text-xs text-ld-neutral-500 mb-6">
                  {{ t('mfaFaqText1') }}
                  <a
                    routerLink="/dashboard"
                    target="_blank"
                    class="text-ld-primary underline cursor-pointer hover:text-ld-primary-hover"
                  >
                    {{ t('mfaFaqLink') }}
                  </a>
                  {{ t('mfaFaqText2') }}
                </p>
              }
              <div class="flex flex-col gap-3">
                @if (data.emailOptions.length > 0) {
                  <button
                    id="link-loan-mfa-dialog-email-btn"
                    type="button"
                    class="btn-primary-ld-purple mfa-dialog-action-btn"
                    (click)="onSelectEmail()"
                  >
                    <span class="mfa-dialog-btn-icon">
                      <img [src]="mailIcon" width="20" height="20" alt="" aria-hidden="true" />
                    </span>
                    <span class="mfa-dialog-btn-label">{{ t('mfaReceiveViaEmail') | uppercase }}</span>
                  </button>
                }
                @if (data.textOptions.length > 0) {
                  <button
                    id="link-loan-mfa-dialog-text-btn"
                    type="button"
                    class="btn-primary-ld-purple mfa-dialog-action-btn"
                    (click)="onSelectText()"
                  >
                    <span class="mfa-dialog-btn-icon">
                      <img [src]="textIcon" width="20" height="20" alt="" aria-hidden="true" />
                    </span>
                    <span class="mfa-dialog-btn-label">{{ t('mfaReceiveViaText') | uppercase }}</span>
                  </button>
                }
                @if (data.callOptions.length > 0) {
                  <button
                    id="link-loan-mfa-dialog-call-btn"
                    type="button"
                    class="btn-primary-ld-purple mfa-dialog-action-btn"
                    (click)="onSelectCall()"
                  >
                    <span class="mfa-dialog-btn-icon">
                      <img [src]="phoneIcon" width="20" height="20" alt="" aria-hidden="true" />
                    </span>
                    <span class="mfa-dialog-btn-label">{{ t('mfaReceiveViaCall') | uppercase }}</span>
                  </button>
                }
              </div>
            }

            @case ('enter-code') {
              <ld-verification-code-card
                #verificationCodeCard
                id="link-loan-mfa-dialog-verification-code"
                [embedded]="true"
                [showLogo]="false"
                [showTitle]="false"
                [maskedContact]="maskedContact()"
                [verificationType]="getVerificationTypeDisplay()"
                [showRememberDevice]="false"
                [showFaqLink]="true"
                (verify)="onVerify($event)"
                (resend)="onResend()"
                (cancel)="onVerificationCancel()"
              />
            }

            @case ('success') {
              <div id="link-loan-mfa-dialog-success">
                <div id="link-loan-mfa-dialog-success-header" class="flex items-center gap-2 mb-3">
                  <img [src]="checkmarkIcon" width="21" height="21" alt="" aria-hidden="true" class="shrink-0" />
                  <h2
                    id="link-loan-mfa-dialog-success-title"
                    class="font-dm text-lg font-semibold text-ld-neutral-700 m-0"
                  >
                    {{ t('modalsLinkLoanMfaVerified') }}
                  </h2>
                </div>
                <p id="link-loan-mfa-dialog-success-message" class="font-dm text-sm text-ld-neutral-500 mb-6">
                  {{ t('modalsLinkLoanMfaSuccessMessage') }}
                </p>
                <div class="flex justify-center">
                  <button
                    id="link-loan-mfa-dialog-continue-btn"
                    type="button"
                    class="btn-primary-ld-purple min-w-[100px] cursor-pointer"
                    (click)="onConfirmSuccess()"
                  >
                    {{ t('commonButtonsContinue') }}
                  </button>
                </div>
              </div>
            }
          }
        }
      </div>
    </div>
  </div>
</ng-container>
